import React from 'react';
import classNames from 'classnames';
import { Spin } from '@nackle/paper';
import './activity-indicator.less';
export default class ActivityIndicator extends React.Component {
  render() {
    const {
      className,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('activity-indicator', className)
    }, /*#__PURE__*/React.createElement(Spin, {
      size: "large"
    }), children);
  }
}
//# sourceMappingURL=activity-indicator.js.map